import { InternalDatabaseService } from '@stockcare-storage/internal/internal-database.service';
import { Stock } from './stock';
import { Injectable } from '@angular/core';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { Settings } from '@stockcare-helpers/settings';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';

@Injectable({
  providedIn: 'root',
})
export class StockStorageService {
  readonly table: string;
  readonly barcodeIndex: string;
  enableLocalDB: boolean;
  stockOnHand: Stock[] = [];
  constructor(
    private internalDatabaseService: InternalDatabaseService,
    private readonly settingsService: SettingsService,
    private readonly deviceService: DeviceService
  ) {
    const table = Stock.getTableDefinition();
    this.table = table.TableName;
    this.barcodeIndex = table.Indexes[0].Name;
    this.getSettings();
  }

  async addStocks(materials: Stock[]) {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.addRange<Stock>(this.table, materials);
    } else {
      this.stockOnHand = [...materials];
    }
  }

  async getStocks(): Promise<Stock[]> {
    if (this.enableLocalDB) {
      return await this.internalDatabaseService.getAll<Stock>(this.table);
    } else {
      return [...this.stockOnHand];
    }
  }

  async getStockByIndex(barcode) {
    if (this.enableLocalDB) {
      return await this.internalDatabaseService.getByIndex<Stock>(this.table, this.barcodeIndex, barcode);
    } else {
      return this.stockOnHand.find((stock) => stock.barcode === barcode);
    }
  }

  async updateStock(stock: Stock): Promise<void> {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.update(this.table, stock);
    } else {
      return new Promise<void>((resolve) => {
        this.stockOnHand = this.stockOnHand.filter((stock) => stock.materialId !== stock.materialId);

        this.stockOnHand.push(stock);
        resolve();
      });
    }
  }

  async deleteAll() {
    if (this.enableLocalDB) {
      await this.internalDatabaseService.deleteAll(this.table);
    } else {
      this.stockOnHand = [];
    }
  }

  getSettings() {
    const theatreDevice = this.deviceService.isTheaterDevice();
    if (theatreDevice) {
      this.enableLocalDB = this.settingsService.getBooleanSetting(Settings.ENABLE_INDEXED_DB);
    } else {
      this.enableLocalDB = true;
    }
  }
}
